export const firebaseConfig = {
  apiKey: 'AIzaSyDWf4rauu5lRPrs3FBHQoLtL3R05znxXK0',
  authDomain: 'idp---indiaai.firebaseapp.com',
  projectId: 'idp---indiaai',
  storageBucket: 'idp---indiaai.firebasestorage.app',
  messagingSenderId: '601330207336',
  appId: '1:601330207336:web:6520cafbc7dbce8b0889dd',
  measurementId: 'G-TK8W7P9DMD',
};
